import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-footerBlue text-white py-4">
      <div className="container mx-auto text-center">
        <p className="flex flex-col md:flex-row space-x-6 font-semibold">
          <span>&copy; {new Date().getFullYear()} IgraoniceBL</span>

          <span
            onClick={() => navigate('/contact')}
            className="cursor-pointer font-semibold"
          >
            Kontakt
          </span>

          <span
            onClick={() => navigate('/terms-of-service')}
            className="cursor-pointer font-semibold"
          >
            Uslovi korišćenja
          </span>

          <span
            onClick={() => navigate('/become-partner')}
            className="cursor-pointer font-semibold"
          >
            Želite postati partner?
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;